// Simple template helpers for letters and PDFs

export interface TemplateUser {
  name: string;
}

export interface TemplateCustomer {
  vorname: string;
  name: string;
  strasse?: string;
  plz?: string;
  ort?: string;
}

export type TemplateType = 'kuendigung' | 'blanko' | 'rueckruf';

export function generateWordTemplate(type: TemplateType, c: TemplateCustomer, u: TemplateUser) {
  const dateStr = new Date().toLocaleDateString('de-DE');
  let s = 'Betreff', b = '', sl = `Signal Iduna - ${u.name} - Münchner Str. 209 - 85757 Karlsfeld`, r = `${c.vorname} ${c.name}<br>${c.strasse || ''}<br>${c.plz || ''} ${c.ort || ''}`, f = `<p>Mit freundlichen Grüßen</p><br><br><p>${u.name}<br>Signal Iduna</p>`;
  if (type === 'kuendigung') { sl = `${c.vorname} ${c.name} - ${c.strasse} - ${c.plz} ${c.ort}`; r = `Signal Iduna<br>Bezirksdirektion ${u.name}<br>Münchner Str. 209<br>85757 Karlsfeld`; s = 'Betreff: Kündigung meiner Versicherung'; b = `<p>Sehr geehrte Damen und Herren,</p><p>hiermit kündige ich meine Versicherung mit der Versicherungsscheinnummer: _________________________</p><p>zum nächstmöglichen Termin / zum: _________________________.</p><p>Bitte senden Sie mir eine schriftliche Kündigungsbestätigung zu.</p>`; f = `<p>Mit freundlichen Grüßen</p><br><br><p>${c.vorname} ${c.name}</p>`; }
  else if (type === 'blanko') { s = 'Betreff: Ihr Anliegen'; b = `<p>Sehr geehrte(r) ${c.name},</p><p></p><p></p>`; }
  else if (type === 'rueckruf') { s = 'Betreff: Bitte um Rückruf'; b = `<p>Sehr geehrte(r) ${c.name},</p><p>ich habe versucht, Sie telefonisch zu erreichen. Bitte rufen Sie mich zwecks Terminvereinbarung oder Besprechung Ihrer Verträge zurück.</p><p>Vielen Dank.</p>`; }
  const html = `<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset="utf-8"><title>Doc</title><style>body{font-family:Arial,sans-serif;font-size:11pt;line-height:1.5}.header{font-size:8pt;text-decoration:underline;margin-bottom:30px;color:#555}.recipient-box{margin-bottom:60px;font-weight:bold}.date{text-align:right;margin-bottom:30px}.subject{font-weight:bold;margin-bottom:20px;font-size:12pt}.footer{margin-top:50px}</style></head><body><div class="header">${sl}</div><div class="recipient-box">${r}</div><div class="date">Karlsfeld, den ${dateStr}</div><div class="subject">${s}</div>${b}<div class="footer">${f}</div></body></html>`;
  const blob = new Blob(['\ufeff', html], { type: 'application/msword' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${type}_${c.name}.doc`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function formatEuro(val: number): string {
  return val.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
}
